import React, { useState, useEffect } from "react";
import * as Components from "./Components";
import "./AuthStyle.css";
import logo from "../../assets/Icon.png";
import { Link } from "react-router-dom";
import { LoginForm } from "./loginForm";
import { motion } from "framer-motion";
import { AccountContext } from "./accountContext";
import { SignupForm } from "./signupForm";
import { RiEyeCloseFill, RiEyeFill } from "react-icons/ri";
import HashLoader from "react-spinners/HashLoader";
import { useSelector, useDispatch } from "react-redux";
import {
  customer_login,
  customer_register,
  messageClear,
} from "../../store/reducers/authReducer";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import styled from "styled-components";

const BoxContainerB = styled.div`
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-top: 15%;
  padding-bottom: 10%;
  border-radius: 0px;
  background-color: #fff;
  box-shadow: 0 0 2px rgba(15, 15, 15, 0.28);
  position: relative;
  overflow: hidden;
`;

const BackDropB = styled(motion.div)`
  width: 160%;
  height: 550px;
  position: absolute;
  display: flex;
  flex-direction: column;
  border-radius: 50%;
  transform: rotate(60deg);
  top: -295px;
  left: -16px;
  background: rgb(30, 41, 81);
  background: linear-gradient(180deg, #212730 0%, #212730 10%, #212730 100%);
`;

const HeaderContainerB = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const HeaderTextB = styled.h2`
  font-family: timesFont;
  font-size: 30px;
  font-weight: 600;
  line-height: 1.24;
  color: #fff;
  z-index: 10;
  margin: 0;
`;

const SmallTextB = styled.h5`
  color: #fff;
  font-weight: 500;
  font-size: 16px;
  z-index: 10;
  margin: 0;
  margin-top: 10px;
`;

const backdropBVariantsB = {
  expanded: {
    width: "233%",
    height: "1050px",
    borderRadius: "20%",
    transform: "rotate(60deg)",
  },
  collapsed: {
    width: "160%",
    height: "700px",
    borderRadius: "50%",
    transform: "rotate(60deg)",
  },
};

const expandingTransitionB = {
  type: "spring",
  duration: 2.3,
  stiffness: 30,
};

function AccountBox(props) {
  const [isExpanded, setExpanded] = useState(false);
  const [active, setActive] = useState("signin");

  const playExpandingAnimation = () => {
    setExpanded(true);
    setTimeout(() => {
      setExpanded(false);
    }, expandingTransitionB.duration * 1000 - 1500);
  };

  const switchToSignup = () => {
    playExpandingAnimation();
    setTimeout(() => {
      setActive("signup");
    }, 400);
  };

  const switchToSignin = () => {
    playExpandingAnimation();
    setTimeout(() => {
      setActive("signin");
    }, 400);
  };

  const contextValue = { switchToSignup, switchToSignin };

  return (
    <>
      <AccountContext.Provider value={contextValue}>
        <BoxContainerB>
          <div>
            <BackDropB
              initial={false}
              animate={isExpanded ? "expanded" : "collapsed"}
              variants={backdropBVariantsB}
              transition={expandingTransitionB}
            />
            {/* {active === "signin" && ( */}
            <HeaderContainerB>
              <HeaderTextB>Ariz Supermart</HeaderTextB>
              <SmallTextB>Pakistan</SmallTextB>
            </HeaderContainerB>
            {/* )}
                    {active === "signup" && (
                        <HeaderContainerB>
                            <HeaderTextB>Create</HeaderTextB>
                            <HeaderTextB>Account</HeaderTextB>
                            <SmallTextB>Please sign-up to continue!</SmallTextB>
                        </HeaderContainerB>
                    )} */}
          </div>
          <div>
            {active === "signin" && <LoginForm />}
            {active === "signup" && <SignupForm />}
          </div>
          <div></div>
        </BoxContainerB>
      </AccountContext.Provider>
    </>
  );
}

function AuthForm() {
  const [signIn, toggle] = React.useState(true);
  const { loader, successMessage, errorMessage, userInfo } = useSelector(
    (state) => state.auth
  );
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const [state, setState] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
  const inputHandle = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };
  const login = (e) => {
    e.preventDefault();
    dispatch(customer_login(state));
  };
  const register = (e) => {
    e.preventDefault();
    dispatch(customer_register(state));
  };
  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
    if (errorMessage) {
      toast.error(errorMessage);
      dispatch(messageClear());
    }
    if (userInfo) {
      navigate("/");
    }
  }, [successMessage, errorMessage]);
  return (
    <div>
      <div className="w-full h-[100vh] sm:hidden flex flex-col justify-center items-center gap-5 ">
        <div className="flex justify-between sm:hidden items-center mt-[-5%]">
          <Link className="flex justify-center items-center" to="/">
            <img className="h-18 w-20" src={logo} alt="Logo" />
            <span className="font-[Montserrat,_sans-serif] text-[27px] text-[#ff700e] tracking-[2px] ">
              Ariz Supermart
            </span>
          </Link>
        </div>

        {loader && (
          <div className="w-screen h-screen flex justify-center items-center fixed left-0 top-0 bg-[#38303033] z-[999]">
            <HashLoader color="#4ff7c2" />
          </div>
        )}
        <Components.Container>
          <Components.SignUpContainer signinIn={signIn}>
            <Components.Form onSubmit={register}>
              <Components.Title>Create Account</Components.Title>
              <Components.Input
                onChange={inputHandle}
                value={state.name}
                type="text"
                id="name"
                name="name"
                placeholder="Name"
                required
              />
              <Components.Input
                onChange={inputHandle}
                value={state.email}
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                required
              />
              <div className="flex items-center ">
                <Components.Input
                  onChange={inputHandle}
                  value={state.password}
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Password"
                  required
                />
                <button
                  type="button"
                  className="block bg-[#eee] py-4 px-3 cursor-pointer"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
                </button>
              </div>
              <Components.Button>Sign Up</Components.Button>
            </Components.Form>
          </Components.SignUpContainer>

          <Components.SignInContainer signinIn={signIn}>
            <Components.Form onSubmit={login}>
              <Components.Title>Sign in</Components.Title>
              <Components.Input
                onChange={inputHandle}
                value={state.email}
                type="email"
                id="email"
                name="email"
                placeholder="Email"
                required
              />
              <div className="flex items-center">
                <Components.Input
                  onChange={inputHandle}
                  value={state.password}
                  type={showPassword ? "text" : "password"}
                  id="password"
                  name="password"
                  placeholder="Password"
                  required
                />
                <button
                  type="button"
                  className="block bg-[#eee] py-4 px-3 cursor-pointer"
                  onClick={togglePasswordVisibility}
                >
                  {showPassword ? <RiEyeFill /> : <RiEyeCloseFill />}
                </button>
              </div>
              <Components.Button>Sign In</Components.Button>
            </Components.Form>
          </Components.SignInContainer>

          <Components.OverlayContainer signinIn={signIn}>
            <Components.Overlay signinIn={signIn}>
              <Components.LeftOverlayPanel signinIn={signIn}>
                <Components.Title>Welcome Back!</Components.Title>
                <Components.Paragraph>
                  To keep connected with us please login with your personal info
                </Components.Paragraph>
                <Components.GhostButton onClick={() => toggle(true)}>
                  Sign In
                </Components.GhostButton>
              </Components.LeftOverlayPanel>

              <Components.RightOverlayPanel signinIn={signIn}>
                <Components.Title>Hello, Friend!</Components.Title>
                <Components.Paragraph>
                  Enter Your personal details and start journey with us
                </Components.Paragraph>
                <Components.GhostButton onClick={() => toggle(false)}>
                  Sigin Up
                </Components.GhostButton>
              </Components.RightOverlayPanel>
            </Components.Overlay>
          </Components.OverlayContainer>
        </Components.Container>
      </div>
      <div className="w-full h-[90vh] xs:h-[100vh] hidden sm:block">
        <AccountBox />
      </div>
    </div>
  );
}

export default AuthForm;
